import { action } from 'typesafe-actions';

import { TravelsAwaitingResponse } from 'models/travelApproved';

export const PENDING_TRAVELS_ADMIN_REQUEST = 'TRAVELS_ADMIN_REQUEST';
export const FETCH_PENDING_TRAVELS_ADMIN_SUCCESSFUL = 'FETCH_PENDING_TRAVELS_ADMIN_SUCCESSFUL';
export const FETCH_PENDING_TRAVELS_ADMIN_FAILURE = 'FETCH_PENDING_TRAVELS_ADMIN_FAILURE';

export const pendingTravelAdminRequest = () => action(PENDING_TRAVELS_ADMIN_REQUEST);

export const fetchPendingTravelAdmin = (travel: TravelsAwaitingResponse) =>
  action(FETCH_PENDING_TRAVELS_ADMIN_SUCCESSFUL, travel);

export const fetchPendingTravelAdminError = (error: string) => action(FETCH_PENDING_TRAVELS_ADMIN_FAILURE, error);
